import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Alert } from "@mui/material";
import { api } from "../../../../api/client";
import { endpoints } from "../../../../api/endpoints";
import useRemote from "../../../../hooks/useRemote";
import useVideoProgress from "../../../../hooks/useVideoProgress";
import { useSession } from "../../../../contexts/SessionContext";
import VideoPlayer from "../../../shares/videoPlayer/VideoPlayer";

export default function Session() {
  const { Id } = useParams();
  const { contentId, setContentId, setClassroom, setsideBar } = useSession();
  const classroom = useRemote(async (signal) => (await api.request({
    url: endpoints.classrooms.detail(Id), signal, safeRead: true,
  })).data, Id);
  const progress = useVideoProgress(Id, contentId);
  useEffect(() => {
    setClassroom(classroom.data); setsideBar(true);
    const first = [1, 2, 3, 4, 5].find((number) => classroom.data?.Class?.["content" + number + "_url1"]);
    if (first) setContentId(first);
    return () => { setClassroom(null); setsideBar(false); };
  }, [classroom.data, setClassroom, setContentId, setsideBar]);
  const video = classroom.data?.Class?.["content" + contentId + "_url1"];
  return <section className="space-y-6 pb-12">
    <Link to="/dashboard/classes">بازگشت به جلسات</Link>
    <h1 className="text-2xl">{classroom.data?.Class?.ClassroomName}</h1>
    {classroom.loading && <p role="status">در حال دریافت جلسه…</p>}
    {classroom.error && <Alert severity="error">{classroom.error.message}</Alert>}
    {progress.error && <Alert severity="warning">{progress.error}</Alert>}
    <div className="flex gap-6">
      <p>حضور این بخش: {progress.result?.percent ?? "—"}٪</p>
      <p>حضور کل: {progress.result?.overall_percent ?? classroom.data?.Presence?.classroom_presence_percentage ?? "—"}٪</p>
    </div>
    {video ? <VideoPlayer key={Id + ":" + contentId} video={video} {...progress} /> : !classroom.loading && <p>ویدیویی برای این بخش وجود ندارد.</p>}
  </section>;
}
